<template lang="pug">
modal.checkbox-settings-modal(
  :close-button-label='$t("button.cancel")'
  :disable-process-button='invalidForm'
  :process-button-label='$t("button.save")'
  :title='$t("modal.checkbox_settings.title")'
  @opened='onOpenModal'
  @process='process'
  ref='modal'
  size='sm'
)
  .col-12
    form.needs-validation(novalidate)
      .form-group
        label.mb-2(for='field-checkbox-name')
          | {{ $t('modal.checkbox_settings.instruction') }}
        .form-control-icon
          icon(name='square-check')
          input#field-checkbox-name.form-control(
            :placeholder='$t("modal.checkbox_settings.placeholder")'
            @blur='validate'
            @input='validate'
            autocomplete='off'
            maxlength='40'
            required
            type='text'
            v-model='element.title'
          )
          .invalid-feedback {{ $t('modal.checkbox_settings.invalid_feedback') }}
      .form-group
        .form-check.form-switch
          .d-flex.align-items-center
            input#field-checkbox-required.form-check-input(
              type='checkbox'
              v-model='element.required'
            )
            .ms-3
              label.m-0(for='field-checkbox-required') {{ $t('modal.checkbox_settings.required') }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';

export default {
  components: {
    Modal,
    Icon,
  },
  data() {
    return {
      element: {},
      invalidForm: true,
    };
  },
  methods: {
    onOpenModal() {
      this.validate();
      if (!this.element.title) {
        window
          .jQuery('#field-checkbox-name')
          .removeClass('is-valid')
          .removeClass('is-invalid');
      }
    },
    process() {
      this.element.name = this.element.title;
      this.$emit('settings', this.element);
      this.$refs.modal.close();
    },
    validate() {
      if (this.element.title) {
        this.invalidForm = false;
      } else {
        this.invalidForm = true;
      }
    },
  },
};
</script>
<style lang="stylus">
.checkbox-settings-modal
  .form-check.form-switch
    .form-check-label
      margin: .2rem 0 0 .5rem
</style>
